import { IRegionItem } from 'constants/types';
import { useQuery } from 'hooks/useQuery';
import { listCountries } from 'lib/api/filters';
import { HookQueryOptions, queryKey } from './shared';

export const useCountriesQuery = (
  _payload?: void,
  options?: HookQueryOptions
) =>
  useQuery<IRegionItem[]>(queryKey('countries.list'), () => listCountries(), {
    skip: options?.skip,
  });
